import { css } from "@emotion/css";
import React from "react";
import { resetStyles } from "../../utils";
export function ProcessSidebarStepErrors({ errors }: {
    errors: string[];
}) {
    return (<ul className={styles.list}>
            {errors.map((error, i) => (<li key={i}>{error}</li>))}
        </ul>);
}
const styles = {
    list: css({
        ...resetStyles.list,
    }),
};
